import { createSlice } from '@reduxjs/toolkit';
import { Status } from '@api';

const _user = {
  user_id: null,
  name: null,
  phone: null,
  email: null,
  image: null,
  login_at: null,
  main_balance: 0,
  bonus: 0,
  level: -1,
};

const initialState = {
  /**
   * If sessionStatus === Status.DEFAULT  => User is not logged in
   * If sessionStatus === Status.SUCCESS  => User is logged in
   * If sessionStatus === Status.ERROR    => session token of logged in user has expired
   */
  sessionStatus: Status.DEFAULT,
  isLocked: false,
  token: '',
  user: _user,
  openLoginAlert: false,
};

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    saveToken: (state, action) => {
      state.token = action.payload;
      state.sessionStatus = Status.SUCCESS;
    },
    clearToken: (state, action) => {
      state.token = '';
      state.sessionStatus = Status.DEFAULT;
      state.isLocked = false;
    },
    saveUser: (state, action) => {
      state.user = action.payload;
    },
    clearUser: (state, action) => {
      state.user = _user;
    },
    setOpenLoginAlert: (state, action) => {
      state.openLoginAlert = action.payload;
    },
    sessionExpired: (state, action) => {
      state.sessionStatus = Status.ERROR;
    },
    accountLocked: (state) => {
      state.isLocked = true;
    }
  },
});

export const {
  saveToken,
  clearToken,
  saveUser,
  clearUser,
  setOpenLoginAlert,
  sessionExpired,
  accountLocked,
} = authSlice.actions;

export default authSlice.reducer;
